import styled from "styled-components";
import { ChannelDataEditorWrapper } from "../../ChannelDataEditor/styles";

export const PostEditorWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 554px;
  ${(props) => props.mobile && "margin: -20px 0 -30px 0;"}
`;

export const MobileContent = styled.div`
  ${(props) =>
    props.mobile &&
    `
  max-height: 630px;
  background: #fff;
  z-index: 1;
`}
`;

export const GoogleSearchEditorWrapper = styled.div`
  padding: 7px 5px 0 5px;
`;

export const GoogleSearchEditor = styled.div`
  padding: 10px;
  background: #fff;
  border: 1px solid #e8e8eb;
  box-shadow: 0px 2px 4px ${(props) => (props.mobile ? "3px" : "0px")} #1516331f;
  border-radius: 8px;
  width: ${(props) => (props.mobile ? "330px" : "555px")};
`;

export const MobileTop = styled.img`
  width: 430px;
`;

export const MobileSide = styled.img`
  width: 44px;
`;

export const MobileBottom = styled.img`
  width: 430px;
`;

export const MobileSearch = styled.img`
  width: 340px;
`;

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  margin: 0 6px;

  ${ChannelDataEditorWrapper} {
    width: 90%;
  }
`;

export const Line = styled.div`
  background: #eeeeee;
  margin: 5px 6px;
  height: 1px;
`;

export const AdBox = styled.div`
  color: #006621;
  border-radius: 3px;
  font-size: 11px;
  border: 1px solid #006621;
  padding: 1px 2px;
`;

export const urlStyle = {
  fontSize: "14px",
  color: "#006621",
  textAlign: "left"
};

export const teaserTextStyle = {
  fontSize: "13px",
  color: "#545454"
};
